import { cn } from "@/lib/utils";

export const CTAButton = ({ as: Tag = "a", variant = "primary", className, children, ...props }) => {
  const base =
    "inline-flex items-center justify-center gap-2 rounded-full font-semibold px-7 py-3.5 text-base transition-transform duration-200 will-change-transform focus:outline-none focus-visible:ring-2 focus-visible:ring-gold-500 focus-visible:ring-offset-2";
  const variants = {
    primary:
      "bg-gold-500 text-navy-900 hover:bg-gold-400 hover:-translate-y-0.5 shadow-[0_6px_20px_-4px_rgba(212,175,55,0.55)]",
    secondary:
      "border-2 border-navy-800 text-navy-800 hover:bg-navy-800 hover:text-cream hover:-translate-y-0.5",
    ghostLight:
      "border-2 border-white/40 text-white hover:bg-white hover:text-navy-900 hover:-translate-y-0.5",
  };
  return (
    <Tag className={cn(base, variants[variant], className)} {...props}>
      {children}
    </Tag>
  );
};

export const SectionLabel = ({ children, dark = false, className }) => (
  <span
    className={cn(
      "inline-block text-xs md:text-sm font-bold uppercase tracking-[0.22em]",
      dark ? "text-gold-400" : "text-gold-600",
      className
    )}
  >
    {children}
  </span>
);

export const Logo = ({ dark = false, className }) => (
  <a href="#home" className={cn("flex items-center gap-2.5 group", className)} data-testid="site-logo">
    <span className="relative flex h-9 w-9 items-center justify-center rounded-xl bg-gold-500 text-navy-900">
      <span className="font-display text-lg font-bold leading-none">K</span>
      <span className="absolute -right-0.5 -top-0.5 h-2 w-2 rounded-full bg-navy-800" />
    </span>
    <span className="flex flex-col leading-none">
      <span className={cn("font-display text-lg font-bold", dark ? "text-white" : "text-navy-900")}>
        Konek Church
      </span>
      <span className={cn("text-[10px] font-semibold uppercase tracking-[0.18em]", dark ? "text-white/50" : "text-charcoal-700/60")}>
        Giving &amp; Growth
      </span>
    </span>
  </a>
);
